module.exports = __webpack_public_path__ + "static/img/roll.dcc0a73e.gif";